export const personalInfo = {
  name: "Ujjwal Kumar",
  role: "Full-Stack Developer | MERN | Web3 Enthusiast",
  tagline: "Building scalable systems & real-world applications.",
  shortBio:
    "Computer Science Engineer with hands-on experience in MERN stack, backend APIs, and production-level applications. Passionate about building scalable systems, optimizing performance, and solving real-world problems.",
  email: "1dt23is172@dsatm.edu.in",
  github: "https://github.com/Ujjwal092",
  linkedin: "https://www.linkedin.com/in/ujjwalkumar0920",
  resumeUrl: "/Ujjwal_Resume_Final.pdf",
  availableForWork: true,
};

export const aboutParagraphs = [
  "I’m a Computer Science student focused on building scalable full-stack applications using the MERN stack and backend systems. I enjoy solving real-world problems with clean architecture and efficient code.",
  "I have built and deployed production-level applications including an edtech platform with authentication, payments, and caching optimization, as well as a blockchain-based decentralized application.",
  "Currently, I am actively practicing DSA (450+ problems solved), improving my problem solving skills, and preparing for software engineering roles.",
];

export const stats = [
  { value: "5+", label: "Major Projects" },
  { value: "450+", label: "DSA Problems" },
  { value: "4★", label: "HackerRank" },
  { value: "50+", label: "LeetCode Streak" },
];

export const projects = [
  {
    id: 1,
    title: "CartSyy",
    type: "AI-Powered E-Commerce Platform",
    description:
      "A full-stack e-commerce platform with secure payments, AI-powered recommendations, and an admin management system.",
    highlights: [
      "JWT authentication & role-based access",
      "Stripe payment integration",
      "AI shopping assistant & recommendations",
      "Dockerized backend with automated testing",
    ],
    tech: ["React", "Node.js", "PostgreSQL", "Stripe", "Gemini API", "Docker"],
    liveUrl: "https://cartsyy-ujjwal092s-projects.vercel.app/",
    githubUrl: "https://github.com/Ujjwal092/ShopMate",
    accentColor: "#34d399",
  },
  {
    id: 2,
    title: "GateKeeper",
    type: "Distributed API Rate Limiter",
    description:
      "A Redis-backed distributed rate limiter supporting multiple rate-limiting algorithms with atomic request handling.",
    highlights: [
      "Token Bucket, Sliding Window & Leaky Bucket",
      "Strategy & Factory design patterns",
      "Redis Lua scripts for atomic operations",
      "Dockerized and load tested with k6",
    ],
    tech: ["Node.js", "Redis", "Lua", "Docker", "k6"],
    liveUrl: "https://github.com/Ujjwal092/Gate-Keeper",
    githubUrl: "https://github.com/Ujjwal092/Gate-Keeperr",
    accentColor: "#f59e0b",
  },
  {
    id: 3,
    title: "StudyNotion",
    type: "Full-Stack EdTech Platform",
    description:
      "A full-stack EdTech platform for course creation, learning, payments, and role-based management.",
    highlights: [
      "JWT & Google OAuth authentication",
      "Razorpay payment integration",
      "Redis caching for faster API responses",
      "Role-based student, instructor, and admin portals",
    ],
    tech: ["React", "Node.js", "MongoDB", "Redis", "Razorpay"],
    liveUrl: "https://studynotion-sandy-seven.vercel.app/",
    githubUrl: "Ujjwal092/StudyNotion",
    accentColor: "#60a5fa",
  },

  {
    id: 4,
    title: "Chatefy",
    type: "Real-Time Chat Application",
    description:
      "A real-time chat application enabling instant messaging with secure authentication and a responsive user experience.",
    highlights: [
      "Real-time messaging with Socket.IO",
      "JWT-based authentication",
      "Typing indicators and online presence",
      "Responsive chat interface",
    ],
    tech: ["React", "Node.js", "Express.js", "MongoDB", "Socket.IO", "JWT"],
    liveUrl: "https://chate-fy-mern.vercel.app",
    githubUrl: "Ujjwal092/Chate-fy",
    accentColor: "#22c55e",
  },

  {
    id: 5,
    title: "Vending Machine DApp",
    type: "Blockchain Application",
    description:
      "A decentralized vending machine application using smart contracts and on-chain transactions.",
    highlights: [
      "Solidity smart contracts",
      "MetaMask wallet integration",
      "Oracle-based dynamic pricing",
      "Hardhat testing on Sepolia",
    ],
    tech: ["Solidity", "Hardhat", "Ethers.js", "React"],
    liveUrl: "https://vending-machine-hard-hat.vercel.app/",
    githubUrl: "Ujjwal092/Vending-Machine-HardHat",
    accentColor: "#a78bfa",
  },
];

export const experience = [
  {
    id: 1,
    role: "Software Engineering Intern – Full Stack",
    company: "OriginCore",
    type: "Internship",
    period: "Feb 2026 – Apr 2026",
    contributions: [
      "Built responsive production interfaces from Figma using React.js.",
      "Developed an AI-powered document verification pipeline using Google Vision OCR and Gemini API.",
      "Debugged production issues and collaborated with designers and backend engineers in agile workflows.",
    ],
    accentColor: "#60a5fa",
  },

  {
    id: 2,
    role: "Frontend Developer Intern",
    company: "Skydot Infotech",
    type: "Internship",
    period: "Nov 2025 – Feb 2026",
    contributions: [
      "Built responsive UI components across ERP, LMS, and ITMS platforms.",
      "Integrated REST APIs with dynamic data rendering.",
      "Collaborated with cross-functional teams to deliver production-ready features.",
    ],
    accentColor: "#34d399",
  },
];

export const achievements = [
  {
    icon: "🏆",
    title: "DSA Practice",
    desc: "Solved 450+ problems across LeetCode, HackerRank, CodeChef , takeUforward, and GeeksforGeeks",
    color: "#fbbf24",
  },
  {
    icon: "⭐",
    title: "HackerRank",
    desc: "Achieved 4★ in Problem Solving",
    color: "#60a5fa",
  },
  {
    icon: "🔥",
    title: "Consistency",
    desc: "Maintained 50+ day LeetCode streak",
    color: "#a78bfa",
  },
];

export const certifications = [
  {
    icon: "🎓",
    name: "Full Stack Web Development Bootcamp",
    issuer: "CodeHelp",
    colorClass: "blue",
  },
  {
    icon: "📘",
    name: "Blockchain",
    issuer: "Infosys Springboard",
    colorClass: "green",
  },
];

export const skills = [
  {
    category: "Languages",
    color: "#60a5fa",
    items: ["Java", "JavaScript", "SQL"],
  },
  {
    category: "Frontend",
    color: "#a78bfa",
    items: [
      "React.js",
      "Redux",
      "Tailwind CSS",
      "HTML5",
      "CSS3",
      "Responsive UI",
    ],
  },
  {
    category: "Backend & APIs",
    color: "#34d399",
    items: [
      "Node.js",
      "Express.js",
      "REST APIs",
      "Socket.IO",
      "JWT Authentication",
      "Redis",
      "Rate Limiting",
      "Webhooks",
      "Razorpay",
      "Stripe",
      "Google OAuth",
      "Google Vision OCR",
    ],
  },
  {
    category: "Databases",
    color: "#fbbf24",
    items: ["MongoDB", "PostgreSQL", "MySQL", "Redis"],
  },
  {
    category: "Blockchain",
    color: "#8b5cf6",
    items: [
      "Solidity",
      "Rust",
      "Smart Contracts",
      "Ethereum (EVM)",
      "Hardhat",
      "Ethers.js",
      "MetaMask",
    ],
  },
  {
    category: "AI & GenAI",
    color: "#f472b6",
    items: [
      "OpenAI (ChatGPT)",
      "Claude",
      "Prompt Engineering",
      "AI-Assisted Development",
    ],
  },
  {
    category: "Core CS",
    color: "#22c55e",
    items: [
      "Data Structures & Algorithms",
      "OOP",
      "DBMS",
      "Operating Systems",
      "Computer Networks",
    ],
  },
  {
    category: "Tools & Platforms",
    color: "#60a5fa",
    items: [
      "Git",
      "GitHub",
      "Postman",
      "VS Code",
      "Chrome DevTools",
      "Cloudinary",
      "Figma",
      "Remix IDE",
    ],
  },
  {
    category: "Deployment",
    color: "#34d399",
    items: ["Vercel", "Render", "Netlify"],
  },
];
